import src from "IMAGE";
export default { src, width: 125, height: 132, blurWidth: 0, blurHeight: 0};
